import React, { useState } from "react";
import ConfirmationModal from "../../../components/ConfirmationModal";
import QrcodeModal from "../../../components/QrcodeModal";
import WhatsAppModal from "../../../components/WhatsAppModal";
import WhatsAppOficialModal from "../../../components/WhatsAppOficialModal";
import WhatsAppFacebookModal from "../../../components/WhatsAppFacebookModal";
import ReconnectProgressModal from "../../../components/ReconnectProgressModal";
import DisconnectProgressModal from "../../../components/DisconnectProgressModal";
import DeleteWhatsAppModal from "../../../components/DeleteWhatsAppModal";
import WebFormModal from "../../../components/WebFormModal";
import TelegramConnectionModal from "../../../components/TelegramConnectionModal";
import TelegramUserConnectionModal from "../../../components/TelegramUserConnectionModal";
import TelegramUserEditModal from "../../../components/TelegramUserConnectionModal/TelegramUserEditModal";
import BaileysConnectionModal from "../../../components/BaileysConnectionModal";
import EmailConnectionModal from "../../../components/EmailConnectionModal";

const ConnectionModals = ({
  // ConfirmationModal
  confirmModalInfo,
  confirmModalOpen,
  onCloseConfirmModal,
  onDisconnectWhatsApp,
  onDeleteWhatsApp,
  // QrcodeModal
  qrModalOpen,
  onCloseQrModal,
  selectedWhatsApp,
  whatsAppModalOpen,
  // WhatsAppModal
  onCloseWhatsAppModal,
  onSaveWhatsApp,
  newConnectionProvider,
  // ReconnectProgressModal
  reconnectModalOpen,
  setReconnectModalOpen,
  setReconnectingWhatsApp,
  reconnectingWhatsApp,
  // DisconnectProgressModal
  disconnectModalOpen,
  setDisconnectModalOpen,
  setDisconnectingWhatsApp,
  disconnectingWhatsApp,
  // DeleteWhatsAppModal
  deleteModalOpen,
  setDeleteModalOpen,
  setDeletingWhatsApp,
  deletingWhatsApp,
  onCompleteDelete,
  onDeleteComplete,
  // WebFormModal (doc 0417) — modal propio, mismo patrón que los de WhatsApp
  webFormModalOpen,
  onCloseWebFormModal,
  editingWebFormId,
  onSaveWebForm,
}) => {
  // WABA (Meta Cloud API oficial) usa un modal DEDICADO; el genérico queda para lo que no tiene modal propio.
  const isWaba =
    selectedWhatsApp?.provider === "waba" ||
    (!selectedWhatsApp?.id && newConnectionProvider === "waba");

  // Facebook Messenger / Instagram: modal dedicado propio (0373 FB1). Un flag por canal para el provider.
  const isFacebook =
    selectedWhatsApp?.provider === "facebook" ||
    (!selectedWhatsApp?.id && newConnectionProvider === "facebook");
  // La primera rama —EDITAR una conexión de Instagram ya existente— es la que sigue en uso.
  // La segunda (alta nueva) quedó inerte al retirar del menú el "Instagram vía Facebook":
  // hoy Instagram entra solo por Business Login, que no pasa por este modal. Se conserva
  // para no cerrar la puerta si el alta manual vuelve a ofrecerse.
  const isInstagram =
    selectedWhatsApp?.provider === "instagram" ||
    (!selectedWhatsApp?.id && newConnectionProvider === "instagram");
  const isFacebookLike = isFacebook || isInstagram;

  // Telegram (doc 0438): modal propio, sin QR — token de @BotFather.
  const isTelegram =
    selectedWhatsApp?.provider === "telegram" ||
    (!selectedWhatsApp?.id && newConnectionProvider === "telegram");
  // Telegram CUENTA PERSONAL (doc 0438 Parte V): el alta es por QR en su modal. Editar una ya creada
  // (colas, flujo, IA) usa el genérico, como el resto de canales.
  const isTelegramUserNew = !selectedWhatsApp?.id && newConnectionProvider === "telegram_user";
  const isTelegramUserEdit = Boolean(selectedWhatsApp?.id) && selectedWhatsApp?.provider === "telegram_user";
  // Correo (doc 0445): un solo modal para alta y edición; el genérico no sabe de buzones.
  const isEmail = selectedWhatsApp?.id ? selectedWhatsApp?.provider === "email" : newConnectionProvider === "email";
  // API Baileys (doc 0439 S6): modal propio y compacto. "beta" es el alias histórico de Baileys.
  // El botón avanzado de Telegram y los proveedores sin modal propio siguen con el genérico.
  const isBaileys = selectedWhatsApp?.id
    ? ["baileys", "beta"].includes(selectedWhatsApp?.provider || "baileys")
    : newConnectionProvider === "baileys";

  // Colas, flujo, IA y transferencias de una conexión Telegram: el modal genérico, sin duplicarlo.
  const [telegramAvanzado, setTelegramAvanzado] = useState(false);
  const cerrarModalConexion = () => {
    setTelegramAvanzado(false);
    onCloseWhatsAppModal();
  };

  return (
  <>
    <ConfirmationModal
      title={confirmModalInfo.title}
      open={confirmModalOpen}
      onClose={onCloseConfirmModal}
      onConfirm={confirmModalInfo.action === "disconnect" ? onDisconnectWhatsApp : onDeleteWhatsApp}
    >
      {confirmModalInfo.message}
    </ConfirmationModal>
    <QrcodeModal
      open={qrModalOpen}
      onClose={onCloseQrModal}
      whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
    />
    <WhatsAppModal
      open={whatsAppModalOpen && ((!isWaba && !isFacebookLike && !isTelegram && !isBaileys && !isTelegramUserNew && !isTelegramUserEdit && !isEmail) || (isTelegram && telegramAvanzado))}
      onClose={cerrarModalConexion}
      whatsAppId={!qrModalOpen && !isBaileys && !isTelegramUserEdit && selectedWhatsApp?.id}
      onSave={onSaveWhatsApp}
      defaultProvider={newConnectionProvider}
    />
    <WhatsAppOficialModal
      open={whatsAppModalOpen && isWaba}
      onClose={onCloseWhatsAppModal}
      whatsAppId={selectedWhatsApp?.id}
      onSave={onSaveWhatsApp}
    />
    <WhatsAppFacebookModal
      open={whatsAppModalOpen && isFacebookLike}
      onClose={onCloseWhatsAppModal}
      whatsAppId={selectedWhatsApp?.id}
      onSave={onSaveWhatsApp}
      provider={isInstagram ? "instagram" : "facebook"}
    />
    {/* Se monta solo al abrirse: su hook (el mismo del genérico) pide datos al montarse, y dos
        instancias montadas duplicarían cada petición de la página. */}
    {whatsAppModalOpen && isBaileys && (
      <BaileysConnectionModal
        open
        onClose={onCloseWhatsAppModal}
        whatsAppId={selectedWhatsApp?.id}
        onSave={onSaveWhatsApp}
      />
    )}
    {whatsAppModalOpen && isEmail && (
      <EmailConnectionModal open onClose={onCloseWhatsAppModal} whatsAppId={selectedWhatsApp?.id} onSave={onSaveWhatsApp} />
    )}
    {whatsAppModalOpen && isTelegramUserNew && (
      <TelegramUserConnectionModal open onClose={onCloseWhatsAppModal} onSave={onSaveWhatsApp} />
    )}
    {/* Como el de Baileys: su hook pide datos al montarse, así que solo se monta abierto. */}
    {whatsAppModalOpen && isTelegramUserEdit && (
      <TelegramUserEditModal open onClose={onCloseWhatsAppModal} whatsAppId={selectedWhatsApp.id} onSave={onSaveWhatsApp} />
    )}
    <TelegramConnectionModal
      open={whatsAppModalOpen && isTelegram && !telegramAvanzado}
      onClose={cerrarModalConexion}
      whatsAppId={selectedWhatsApp?.id}
      onSave={onSaveWhatsApp}
      onOpenAdvanced={() => setTelegramAvanzado(true)}
    />
    <ReconnectProgressModal
      open={reconnectModalOpen}
      onClose={() => {
        setReconnectModalOpen(false);
        setReconnectingWhatsApp(null);
      }}
      whatsAppName={reconnectingWhatsApp?.name || "WhatsApp"}
      whatsAppId={reconnectingWhatsApp?.id}
    />
    <DisconnectProgressModal
      open={disconnectModalOpen}
      onClose={() => {
        setDisconnectModalOpen(false);
        setDisconnectingWhatsApp(null);
      }}
      whatsAppName={disconnectingWhatsApp?.name || "WhatsApp"}
    />
    <DeleteWhatsAppModal
      open={deleteModalOpen}
      onClose={() => {
        setDeleteModalOpen(false);
        setDeletingWhatsApp(null);
      }}
      whatsAppName={deletingWhatsApp?.name || "WhatsApp"}
      whatsAppId={deletingWhatsApp?.id}
      onConfirm={onCompleteDelete}
      onDeleteComplete={onDeleteComplete}
    />
    <WebFormModal
      open={webFormModalOpen}
      onClose={onCloseWebFormModal}
      webFormId={editingWebFormId}
      onSave={onSaveWebForm}
    />
  </>
  );
};

export default ConnectionModals;
